export default "/_next/static/images/book-demo-background-legacy-493d38d5a55310edd4f05859ed9b803b.png";